import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ spacing, palette }) => ({
  about: {
    gridArea: "CirclesBanner",
    backgroundColor: palette.secondary.main,
    padding: `${spacing(5)}px ${spacing(5)}px`,
    display: "grid",
    gridTemplateColumns: "repeat(3, 20rem)",
    gridTemplateRows: "20rem",
    gap: spacing(2),
    justifyContent: "space-around",
  },
  about2: {
    gridArea: "CirclesBanner",
    display: "flex",
    padding: "20px",
    backgroundColor: palette.secondary.main,
    flexDirection: "column",
  },
  driver: {
    gridArea: "CirclesBanner",
    backgroundColor: "#ffffff",
    padding: `${spacing(5)}px ${spacing(5)}px`,
    display: "grid",
    gridTemplateColumns: "repeat(3, 20rem)",
    gridTemplateRows: "20rem",
    gap: spacing(2),
    justifyContent: "space-around",
  },
  circle: {
    border: `solid 18px ${palette.primary.main}`,
    borderRadius: "50%",
    display: "grid",
    placeItems: "center",
  },
  circleCont: {
    position: "relative",
    width: "100%",
    paddingBottom: "100%",
    marginBottom: "10px",
  },
  circle2: {
    border: `solid 18px ${palette.primary.main}`,
    borderRadius: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    placeItems: "center",
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  icon: {
    fontSize: "4em",
    color: "#133257",
  },
  iconAbout: {
    fontSize: "4em",
    color: "#ffffff",
  },
  iconAboutMob: {
    fontSize: "10em",
    color: "#ffffff",
  },
  text: {
    color: "#133257",
    fontWeight: "bold",
    fontSize: "24px",
    lineHeight: "29px",
    textAlign: "center",
    width: "85%",
    margin: `0 0 ${spacing(5)}px 0`,
  },
  textAbout: {
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "24px",
    lineHeight: "29px",
    textAlign: "center",
    width: "85%",
    margin: `0 0 ${spacing(5)}px 0`,
  },

  textAboutMob: {
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "40px",
    textAlign: "center",
    width: "85%",
  },
}));

export default useStyles;
